import A from './A'
import ExternalLink from './ExternalLink'
import InternalLink from './InternalLink'

export { A, ExternalLink, InternalLink }

export default A
